
import { controls } from "../../../../pages/controls";

const rp303 = {
  label: "Scroll",
  starting: true,
  url: "rp303",
  pageLabel: "Balance Sheet",
  pageType: "history",
  filter: [
    ...controls.displayText({ label: "Region", width: "col-sm-2" }),
    ...controls.Region(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "region",
      textcolor: "black",
      name: "region_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2", star: true }),

    ...controls.branch({ tab: "filter", isRequired: true }),
    {
      inputType: "showdata",
      tab: "filter",
      data: "branch_display",
      textcolor: "black",
      data: "branch_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
    },
    ...controls.checkBox({ tab: "filter", label: "With Branch", name: "isWitBrabch", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "Transaction Type", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "All",
          value: "All"
        },
        {
          label: "Cash",
          value: "Cash"
        },
        {
          label: "Transfer",
          value: "Transfer"
        },
        {
          label: "Clearing",
          value: "Clearing"
        }
      ],
      placeHolder: "Transaction Type",
      name: "TransactionType",
      description: "Enter Transaction Type"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    {
      inputType: "displaytext",
      tab: "filter",
      star: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "As on Date",
      label: "As on Date",
      name: "",
      description: "Enter As on Date"
    },

    {
      inputType: "date",
      // dateType: "ontype",
      isRequired: true,
      tab: "filter",
      defaultValue: "sessiondate",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "As on Date",
      // displayFormat: "DD/MM/YYYY",
      // outputFormat: "YYYYMMDD",
      name: "as_on_date",
      description: "Enter As on Date"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Receipt/Payment", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Receipts",
          value: "Receipts"
        },
        {
          label: "Payments",
          value: "Payments"
        },
        {
          label: "Receipts And Payments",
          value: "Receipts And Payments"
        },
        {
          label: "Opening balance Receipts And Payments",
          value: "Opening balance Receipts And Payments"
        }, {
          label: "Receipts Payments and Closing balance",
          value: "Receipts Payments and Closing balance"
        }, {
          label: "Opening Balance Receipts Payments and Closing balance",
          value: "Opening Balance Receipts Payments and Closing balance"
        },
      ],
      placeHolder: "Receipt/Payment",
      name: "Receipt_Payment",
      description: "Enter Receipt/Payment"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Balance Sheet",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      fields: ["credit_cash", "debit_cash"],
      grandtotal: { type: "fixed", displayIn: "description", val: "Grand Total", count: true },
    },
    clickable: false,
    displayColumns: [{
      Header: "GL",
      accessor: "gl"
    },
    {
      Header: "Description",
      accessor: "description",
      rwidth: "*"
    },
    {
      Header: "Credit",
      accessor: "credit_cash",
      type: "currency",
    },
    {
      Header: "Debit",
      accessor: "debit_cash",
      type: "currency",
    },]
  }
};

export default rp303;
